import { useCallback, useEffect, useState } from "react";
import { getJobIcon } from "../../../utils/getJobIcon";
import ButtonActionIcon from "../ButtonActionIcon";
import Input from "../../FormComponents/Input";
import MaterialIcon from "../MaterialIcon";
import { getTreeDataForJobsCategory } from "../../../utils/treeData/treeDataUtils";
// import Input from "../../FormComponents/Input";
// import { searchArray } from "../../../commonFunctions/arrayFunc";

const JobCategorySelection = ({ allJobs, selectJob }) => {
  const [jobTemplateMap, setJobTemplateMap] = useState({});
  const [searchQuery, setSearchQuery] = useState("");
  const [isFolderCollapse, setIsFolderCollapse] = useState(false);

  const [openCategories, setOpenCategories] = useState(() => {
    const initialOpenCategories = {};

    getTreeDataForJobsCategory(allJobs).forEach((category) => {
      initialOpenCategories[category.id] = true;
    });
    return initialOpenCategories;
  });

  const [allJobsTreeData, setAllJobsTreeData] = useState([]);

  const fetchTreeData = useCallback(() => {
    return getTreeDataForJobsCategory(allJobs).map((category) => ({
      ...category
    }));
  }, [allJobs]);

  const handleJobClick = (job) => {
    selectJob(job.id, job.parentData, job.name);
  };

  const toggleCategory = (categoryId) => {
    setOpenCategories((prev) => {
      const newState = { ...prev, [categoryId]: !prev[categoryId] };
      return newState;
    });
  };

  const createJobTemplateMap = () => {
    const jobsMap = {};
    allJobs.forEach((job) => {
      jobsMap[job.id] = job.job_template;
    });
    setJobTemplateMap(jobsMap);
  };

  useEffect(() => {
    const data = fetchTreeData();
    setAllJobsTreeData(data);
    createJobTemplateMap();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //   const { result: filteredJobs, err } = searchArray(allJobsTreeData, searchQuery, ["name"]);
  //   if (err) return <p>Error: </p>;

  const handleAllFolderCollapse = () => {
    const newState = {};
    allJobsTreeData.forEach((category) => {
      newState[category.id] = isFolderCollapse;
    });
    setOpenCategories(newState);
    setIsFolderCollapse(!isFolderCollapse);
  };

  const filteredCategories = allJobsTreeData
    .map((category) => ({
      ...category,
      items: category.items.filter((job) => job.name.toLowerCase().includes(searchQuery.toLowerCase()))
    }))
    .filter((category) => category.items.length > 0);

  return (
    <div>
      <div className="d_flex align_center mb_4">
        <div className="position_relative">
          <Input
            placeholder="Search jobs"
            containerClassName="ml_auto"
            inputBoxStyle={{ paddingLeft: "26px", width: "76%" }}
            containerStyle={{ width: "96%" }}
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
          <MaterialIcon name="search" className="job_search" />
        </div>
        <div className="folder_collapse_icon cursor_pointer ml_auto pr_2" onClick={handleAllFolderCollapse}>
          {isFolderCollapse ? <MaterialIcon name="folder" /> : <MaterialIcon name="folder_open" />}
        </div>
      </div>
      {filteredCategories.length > 0 ? (
        filteredCategories.map((category) => (
          <section key={category.id} className="mb_2">
            <div className="folder sidebar_folder_option p_0" onClick={() => toggleCategory(category.id)}>
              <span role="img" aria-label="fileEmoji" className="name">
                <div className="sidebar_folder_name font_size_medium" style={{ fontWeight: "500" }}>
                  <MaterialIcon name={openCategories[category.id] ? "arrow_drop_down" : "arrow_right"} />
                  <span>{category.name}</span>
                </div>
              </span>
            </div>
            {openCategories[category.id] && (
              <div className="folder_files gap_2">
                {category.items.map((job) => (
                  <div key={job.id} className="job_item p_2" onClick={() => handleJobClick(job)}>
                    <div
                      className="file d_flex font_size_medium gap_4 font_weight_medium border_radius_small"
                      style={{
                        border: "1px solid",
                        borderColor: "#DADCE0",
                        height: "58px"
                      }}
                    >
                      <div>
                        {getJobIcon(jobTemplateMap[job.id]) ? (
                          <img
                            src={getJobIcon(jobTemplateMap[job.id])}
                            alt={jobTemplateMap[job.id]}
                            style={{ width: "26px", height: "26px" }}
                          />
                        ) : (
                          <MaterialIcon name="text_fields" />
                        )}
                      </div>
                      <div className="d_grid">
                        <span className="font_size_small">{job.name}</span>
                      </div>
                      <div className="add-button-container ml_auto">
                        <ButtonActionIcon
                          type="add"
                          title="add job"
                          style={{ marginTop: "0px" }}
                          onClick={() => handleJobClick(job)}
                        />
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </section>
        ))
      ) : (
        <p>No jobs found</p>
      )}
    </div>
  );
};

export default JobCategorySelection;
